import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Common/Layout/Header";
import { useAuth } from "../Common/Configurations/AuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faExternalLinkAlt, 
    faGlobe, 
    faUsers, 
    faBriefcase, 
    faBuilding,
    faShoppingCart,
    faEye
} from '@fortawesome/free-solid-svg-icons';
import "./AgentWebsiteShowcase.css";

const AgentWebsiteShowcase = () => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState("Travel");

    const categories = [
        { id: "Travel", label: "Travel Website", icon: faGlobe, color: "info" },
        { id: "B2C", label: "B2C Website", icon: faUsers, color: "success" },
        { id: "B2B", label: "B2B Website", icon: faBriefcase, color: "warning" },
        { id: "Corporate", label: "Corporate Website", icon: faBuilding, color: "primary" }
    ];

    const templateDatabase = {
        "Travel": [
            {
                id: 1,
                title: "Premium DMC Professional",
                desc: "Clean, white-themed DMC interface with blue/orange accents. Perfect for B2B booking engines.",
                path: "/website1",
                badge: "Professional",
                color: "primary",
                img: "/assets/images/Website1.png"
            },
            {
                id: 2,
                title: "Cinematic Luxury",
                desc: "Immersive dark mode with Ken Burns effect sliders. Designed for high-end luxury travel experiences.",
                path: "/website2",
                badge: "Cinematic",
                color: "dark",
                img: "/assets/images/Website2.png"
            },
            {
                id: 3,
                title: "Editorial Voyager",
                desc: "Split-hero layout with forest greens and cream tones. Features masonry grids for storytelling.",
                path: "/website3",
                badge: "Editorial",
                color: "success",
                img: "/assets/images/Website3.png"
            },
            {
                id: 4,
                title: "Sophisticated Classic",
                desc: "Timeless brochure style with serif typography and a sophisticated gold/charcoal palette.",
                path: "/website4",
                badge: "Classic",
                color: "warning",
                img: "/assets/images/Website4.png"
            }
        ],
        "B2C": [
            {
                id: 5,
                title: "B2C Retail Explorer",
                desc: "High-performance flight and holiday portal designed for direct consumer conversion and trust.",
                path: "https://babaair.com/",
                badge: "B2C Live",
                color: "info",
                img: "/assets/images/B2C_Website.png"
            },
             {
                id: 6,
                title: "Modern Consumer Hub",
                desc: "A customer-centric interface with rich visual storytelling and easy search-to-book flow.",
                path: "https://landairtravels.com/",
                badge: "Premium",
                color: "success",
                img: "/assets/images/B2C_Website2.png"
            },
             {
                id: 7,
                title: "Direct Flight Gateway",
                desc: "Simplified mobile-first UI for lightning-fast flight bookings and real-time availability.",
                path: "https://babaair.com/",
                badge: "Conversion",
                color: "primary",
                img: "/assets/images/B2C_Website3.png"
            },
             {
                id: 8,
                title: "Holiday Retailer Pro",
                desc: "Feature-rich template focused on holiday packages, customer reviews, and vibrant destination imagery.",
                path: "/website4",
                badge: "Bestseller",
                color: "warning",
                img: "/assets/images/B2C_Website4.png"
            }
        ],
        "B2B": [
            {
                id: 9,
                title: "Wholesale Agent Portal", 
                desc: "Inventory-heavy layout designed for high-volume transactions and sub-agent management.", 
                badge: "B2B Live", 
                color: "primary", 
                path: "https://b2b.trawtel.com/",
                img: "/assets/images/B2B_Website.png"
            },
             {
                id: 10,
                title: "B2B Reseller Dashboard", 
                desc: "Efficient multi-tier booking system with wallet integration and instant markup controls.", 
                badge: "Professional", 
                color: "info", 
                path: "https://b2b.trawtel.com/",
                img: "/assets/images/B2B_Website2.png"
            },
             {
                id: 11,
                title: "Global Inventory Connect", 
                desc: "Advanced search engine for sub-agents to access global GDS and LCC content seamlessly.", 
                badge: "Scale", 
                color: "dark", 
                path: "https://b2b.trawtel.com/",
                img: "/assets/images/B2B_Website3.png"
            },
             {
                id: 12,
                title: "Enterprise Partner Link", 
                desc: "Robust back-office integration for travel consortia with advanced reporting and finance tracking.", 
                badge: "Enterprise", 
                color: "secondary", 
                path: "https://b2b.trawtel.com/",
                img: "/assets/images/B2B_Website4.png"
            },
        ],
        "Corporate": [
            {
                id: 13,
                title: "Corporate Command Center", 
                desc: "End-to-end travel help desk for modern enterprises with built-in policy compliance.", 
                badge: "Live Site", 
                color: "success", 
                path: "https://myfirstbooking.in",
                img: "/assets/images/Corporate_Website.png"
            },
             {
                id: 14,
                title: "Business Trip Optimizer", 
                desc: "Automated GST invoicing and simplified expense tracking dashboard for corporate travelers.", 
                badge: "Efficiency", 
                color: "primary", 
                path: "https://myfirstbooking.in",
                img: "/assets/images/Corporate_Website2.png"
            },
             {
                id: 15,
                title: "Enterprise Travel Manager", 
                desc: "Seamless employee management and group booking controls for large-scale organizations.", 
                badge: "Admin Pro", 
                color: "info", 
                path: "https://myfirstbooking.in",
                img: "/assets/images/Corporate_Website3.png"
            },
             {
                id: 16,
                title: "SME Business Gateway", 
                desc: "Flexible, lightweight corporate solution tailored for small to mid-sized business travel needs.", 
                badge: "SME Focused", 
                color: "warning", 
                path: "https://myfirstbooking.in",
                img: "/assets/images/Corporate_Website4.png"
            },
        ]
    };
        

    const currentTemplates = templateDatabase[activeTab] || [];

    const handleAddToCart = (template) => {
        alert(`${template.title} added to cart!`);
    };

    return (
        <div id="layout-wrapper" className="agent-website-main-wrapper" style={{ background: '#f3f4f6', minHeight: '100vh' }}>
            <Header User={user} activeSection="website" />
            
            <div className="main-content" style={{ padding: '20px' }}>
                <div className="page-content">
                    <div className="container-fluid">
                        
                        {/* Header Section */}
                        <div className="row mb-4 text-center">
                            <div className="col-lg-8 mx-auto">
                                <h2 className="agent-website-page-title">Website Showcase</h2>
                                <p className="text-muted">Explore and select high-converting templates for your travel business.</p>
                            </div>
                        </div>

                        {/* Category Selectors */}
                        <div className="row justify-content-center mb-5">
                            {categories.map((cat) => (
                                <div key={cat.id} className="col-xl-3 col-md-6 mb-3">
                                    <div 
                                        className={`agent-website-category-card ${activeTab === cat.id ? 'agent-website-active-category' : ''}`}
                                        onClick={() => setActiveTab(cat.id)}
                                    >
                                        <div className="card-body text-center p-4">
                                            <div className={`agent-website-icon-wrapper agent-website-bg-soft-${cat.color} mb-3`}>
                                                <FontAwesomeIcon icon={cat.icon} className={`text-${cat.color} fs-3`} />
                                            </div>
                                            <h5 className="fw-bold text-dark mb-1">{cat.label}</h5>
                                            <span className="text-muted small">Templates</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Templates Display */}
                        <div className="row justify-content-center">
                            {currentTemplates.length > 0 ? (
                                currentTemplates.map((demo) => (
                                    <div key={demo.id} className="col-xl-3 col-md-6 mb-4">
                                        <div className="agent-website-template-card shadow-lg">
                                            
                                            {/* Image Section */}
                                            <div className="agent-website-img-container">
                                                <img 
                                                    src={demo.img} 
                                                    alt={demo.title} 
                                                    className="agent-website-img" 
                                                    onError={(e) => { e.target.src = "https://via.placeholder.com/800x600?text=Preview"; }}
                                                />
                                                <div className="agent-website-img-overlay">
                                                    <Link to={demo.path} target="_blank" className="btn btn-light rounded-pill px-3 fw-bold">
                                                        <FontAwesomeIcon icon={faEye} className="me-1" /> View Live
                                                    </Link>
                                                </div>
                                                <span className={`badge bg-${demo.color} agent-website-template-badge`}>
                                                    {demo.badge}
                                                </span>
                                            </div>

                                            {/* Content Section */}
                                            <div className="card-body p-4 text-center">
                                                <h5 className="fw-bold text-truncate">{demo.title}</h5>
                                                <p className="text-muted small mb-4" style={{ height: '40px', overflow: 'hidden' }}>{demo.desc}</p>
                                                
                                                {/* Action Buttons */}
                                                <div className="agent-website-btn-group">
                                                    <Link 
                                                        to={demo.path} 
                                                        target="_blank" 
                                                        className="agent-website-btn-preview"
                                                    >
                                                        Preview
                                                    </Link>
                                                    <button 
                                                        onClick={() => handleAddToCart(demo)}
                                                        className="agent-website-btn-cart"
                                                    >
                                                        <FontAwesomeIcon icon={faShoppingCart} className="me-1" /> Add to Cart
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-5">
                                    <div className="text-muted">No templates found for this category.</div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgentWebsiteShowcase;